<template>
  <div class="quote-info-wrapper">
    <order-info-block :minimized="true" />
  </div>
</template>

<script>
import OrderInfoBlock from '@/components/generic/presentational/organisms/orderInfoBlock/OrderInfoBlock.vue'

export default {
  components: {
    OrderInfoBlock,
  },
}
</script>

<style lang="scss" scoped>
.quote-info-wrapper {
  zoom: 70%;
}

:deep(.order-info-block) {
  > h5 {
    // hide title
    display: none;
  }

  > dl {
    // info on 1 line
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 0;
  }
}
</style>
